import { render } from "./DocumenteView.vue?vue&type=template&id=4a36b56c&scoped=true&ts=true"
import script from "./DocumenteView.vue?vue&type=script&lang=ts"
export * from "./DocumenteView.vue?vue&type=script&lang=ts"

import "./DocumenteView.vue?vue&type=style&index=0&id=4a36b56c&scoped=true&lang=css"
import "./DocumenteView.vue?vue&type=style&index=1&id=4a36b56c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a36b56c"]])

export default __exports__